const STORAGE_KEY = "cmf.echeqTodoActions";

export function persistEcheqTodoActions(echeqAction) {
    try {
        if (echeqAction?.action) {
            sessionStorage.setItem(STORAGE_KEY, JSON.stringify(echeqAction));
        }
    } catch (e) {
        // sessionStorage unavailable (private mode, quota)
    }
}

export function readPersistedEcheqTodoActions() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        return parsed?.action ? parsed : null;
    } catch (e) {
        return null;
    }
}

export function clearPersistedEcheqTodoActions() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        // ignore
    }
}

/**
 * Restaura echeqsToDoActions desde sessionStorage si Redux quedó vacío tras un refresh.
 * @returns {boolean} true si hay acción disponible (redux o session)
 */
export function restoreEcheqTodoActionsIfNeeded(dispatch, echeqAction, checksActions) {
    if (echeqAction?.action) {
        return true;
    }
    const persisted = readPersistedEcheqTodoActions();
    if (persisted?.action) {
        dispatch(checksActions.setEcheqsToDoActions(persisted));
        return true;
    }
    return false;
}
